import { Flex, Form } from "antd"

import Icon from "../../Icon"
import ButtonComponent from "../Button"
import InputComponent from "../Input"

function SourceOrCampaignForm({ onClose, onSubmit }) {
  const [form] = Form.useForm()

  const onFinish = (values) => {
    onSubmit(values)
  }

  function handleClearError(e, field) {
    form.setFields([
      {
        name: field,
        errors: []
      }
    ])
  }

  function onFocusHandler(e, fieldName) {
    const field = fieldName || e.target.name || e.target.id
    handleClearError(e, field)
  }

  const addErrorIcon = (error) => (
    <span>
      <Icon type={"alert_triangle_error"} /> {error}
    </span>
  )

  const validateMessages = {
    required: addErrorIcon("Required fields were not filled.")
  }

  const validateCodeName = (_, value) => {
    if (!value) return Promise.resolve()

    const trimmed = value.trim()

    if (!/^[a-z0-9-]+$/.test(trimmed)) {
      return Promise.reject(
        new Error(
          "Only lowercase letters, numbers, and hyphens are allowed. No spaces or special characters."
        )
      )
    }

    if (/^[^a-z]/.test(trimmed)) {
      return Promise.reject(new Error("Must start with a lowercase letter."))
    }

    if (/_/.test(trimmed)) {
      return Promise.reject(new Error("Use hyphens instead of underscores."))
    }

    if (/\s/.test(trimmed)) {
      return Promise.reject(new Error("No spaces allowed. Use hyphens instead."))
    }

    if (/--/.test(trimmed)) {
      return Promise.reject(new Error("Avoid consecutive hyphens."))
    }

    if (trimmed.length < 5) {
      return Promise.reject(new Error("Code name is too short. Be descriptive but concise."))
    }

    return Promise.resolve()
  }

  return (
    <Form
      className={"with-default-error"}
      onFinish={onFinish}
      validateTrigger="onSubmit"
      validateMessages={validateMessages}
      layout="vertical"
      form={form}
    >
      <Form.Item name="name" label="Name" rules={[{ required: true }]}>
        <InputComponent
          //placeholder="Enter a new pricing scheme name"
          name="name"
          onFocus={onFocusHandler}
        />
      </Form.Item>

      <Form.Item
        name="code_name"
        label="Code name"
        rules={[{ required: true }, { validator: validateCodeName }]}
      >
        <InputComponent
          //placeholder="Enter a new pricing scheme name"
          name="code_name"
          onFocus={onFocusHandler}
        />
      </Form.Item>
      <Flex gap={16} justify="end" style={{ padding: "0 3px 3px 3px" }}>
        <ButtonComponent size="large" htmlType="button" onClick={onClose}>
          Cancel
        </ButtonComponent>

        <ButtonComponent size="large" type="primary" htmlType="submit">
          Add
        </ButtonComponent>
      </Flex>
    </Form>
  )
}

export default SourceOrCampaignForm
